/**
 * This scripts export a constructor to handle a websocket conection to the CiviiChatServer
 * @param {String} url url to stablish connection to
 * @param {Object} handlersOptions object with handlers to websocket connection events (onOpenHandler, onMessageHandler, onErrorHandler, onCloseHandler)
 */
export default function (url, {onOpenHandler, onMessageHandler, onErrorHandler, onCloseHandler}){
    
    /**
     * this object
     */
    var context = {}
    
    /**
     * Websocket connection to CiviiChatServer
     */
    var connection = null;

    function init(){
        onOpenHandler = validateHandler(onOpenHandler);
        onMessageHandler = validateHandler(onMessageHandler);
        onErrorHandler = validateHandler(onErrorHandler);
        onCloseHandler = validateHandler(onCloseHandler);
        try {
            validateUrl(url);
            stablishConnection();
        } catch (e) {
            onErrorHandler(e);
            throw e;
        }
    }

    function validateUrl(url){
        if(typeof url !== 'string' || !url.toLowerCase().startsWith('ws') || !url.toLowerCase().includes('codigooperacion=')){
            throw new Error(`CiviiChatConnection ERROR: url parameter must:\n- be a string\n- starts with "ws://" protocol\n- includes query param "codigoOperacion="\n and was "${url}" \n`);
        }
    }

    function validateHandler(handler){
        if(!handler){
            handler = function(e){
                console.log('not handler defined, event recived: ', e);
            }
        }
        return handler;
    }

    function stablishConnection (){
        connection = new WebSocket(url);
        connection.onopen = function(e){
            onOpenHandler(e);
        }
    
        connection.onmessage = function(e){
            onMessageHandler(e);
        }
    
        connection.onerror = function(e){
            onErrorHandler(e);
        }

        connection.onclose = function(e){
            onCloseHandler(e);
        }
    }

    context.close = function(){
        connection.close();
    }

    context.sendMessage = function (message) {
        connection.send(message);
    }

    context.isOpen = function(){
        return connection && connection.readyState === connection.OPEN;
    }

    init();
    return context;
}


// WEBPACK FOOTER //
// ./src/civii-chat/scripts/civiiChatConnection.js